<template>
  <div class="about">
    <h1>About Me</h1>
    <div class="row">
      <div class="col item">
        Full Stack Developer with 4+ years of hands-on experience designing,
        developing and implementing applications and solutions using a range of
        technologies and programming languages. Seeking to leverage broad
        development experience and hands-on technical expertise in a challenging
        role as a Full-stack Developer.
      </div>

      <div class="contact-info col item">
        <p class="m-0"><strong>Residence : </strong>Safi, Morocco</p>
        <p class="m-0"><strong>E-Mail : </strong>belboukayyoub@gmail.com</p>
        <p class="m-0"><strong>Phone : </strong>+212 606 196 345</p>
      </div>
    </div>

    <h1>What I Do</h1>
    <div class="row whatido">
      <div class="col item">
        <svg width="60" height="60">
          <use xlink:href="#web-design" />
        </svg>
        <h2 class="m-0">Web Design</h2>
      </div>

      <div class="col item">
        <svg width="60" height="60">
          <use xlink:href="#web-dev" />
        </svg>
        <h2 class="m-0">Web Development</h2>
      </div>
    </div>
    <div class="row whatido">
      <div class="col item">
        <svg width="60" height="60">
          <use xlink:href="#mobile" />
        </svg>
        <h2 class="m-0">Mobile App</h2>
      </div>
      <div class="col item">
        <svg width="60" height="60">
          <use xlink:href="#desktop" />
        </svg>
        <h2 class="m-0">Desktop App</h2>
      </div>
    </div>

    <h1>Clients</h1>
    <div class="row clients">
      <div class="col">
        <img
          src="../assets/images/pl-logo.png"
          alt="ma3akom-logo"
          height="60"
        />
      </div>
      <div class="col">
        <img
          src="../assets/images/ma3akom-logo.png"
          alt="ma3akom-logo"
          height="60"
        />
      </div>
      <div class="col">
        <img
          src="../assets/images/safiart-logo.png"
          alt="ma3akom-logo"
          height="60"
        />
      </div>
    </div>

    <!--p>
      <span style="color: #92aee7"> &lt;!-- Devloper --&gt; </span><br /><br />
      &lt;WebDevloper <br />
      :first="<span style="color: #78af67">BELBOUK</span>" <br />
      :last="<span style="color: #78af67">AYYOUB</span>" <br />
      :age="<span style="color: #d79a51">28</span>" <br />
      :skills="<span style="color: #d79a51"
        >[ <span style="color: #78af67">'HTML'</span>,
        <span style="color: #78af67">'CSS'</span>,
        <span style="color: #78af67">'JS'</span>,
        <span style="color: #78af67">'VUE'</span>,
        <span style="color: #78af67">'PHP'</span>,
        <span style="color: #78af67">'SCSS'</span>,
        <span style="color: #78af67">'SQL'</span>, ]</span
      >" /&gt;<br />
      <br />
      <span style="color: #92aee7"> &lt;!-- /End Devloper --&gt; </span>
    </p-->
  </div>
</template>

<style scoped lang="scss">
.about {
  width: 90%;
  margin: 0 auto;
  & > h1 {
    margin: 0;
    margin-bottom: 25px;
  }
  & > h1:nth-child(2) {
    margin: 25px 0px;
  }

  .item {
    margin-bottom: 25px;
    h2 {
      margin: 10px 0px;
    }
  }
  .whatido {
    text-align: center;
    svg {
      fill: #fdae57;
    }
    h2 {
      color: white;
    }
  }
  .contact-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 14px;
  }
}

@media screen and (max-width: 1024px) {
  .clients {
    .col {
      margin-bottom: 25px;
    }
  }
}
</style>
